let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gR7fm")).then(() => parcelRequire('jwf4n'));